<template>
  <v-card flat>
    <v-card-actions>
      <span class="text-h6">{{ $lang('reservations.title')}}</span>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!options.noImport"
        small
        :disabled="!companyId"
        @click="openImport"
        color="primary"
      >{{ $lang('main.crud.import') }}</v-btn>
    </v-card-actions>
    <v-card-text class="ma-0 pa-0">
      <v-container fluid>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $lang("reservations.fields.period") }}
                </th>
                <th class="text-center">
                  {{ $lang("reservations.fields.property") }}
                </th>
                <th class="text-left">
                  {{ $lang("reservations.fields.client") }}
                </th>
                <th class="text-left">
                  {{ $lang("reservations.fields.amount") }}
                </th>
                <th class="text-left" v-if="reservations.length > 1">
                  {{ $lang("main.crud.actions") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in pagination.items" :key="index">
                <td class="text-left">
                  <v-chip color="secondary" small class="my-1">
                    {{ $toDateFormat(item.start_date, 'DD/MM') }}
                    <v-icon small color="primary">mdi-arrow-right</v-icon>
                    {{ $toDateFormat(item.end_date, 'DD/MM') }}
                  </v-chip>
                </td>
                <td class="text-center">
                  {{ item.property.name }}
                </td>
                <td class="text-left">
                  {{ item.client.name }}
                </td>
                <td class="text-left">
                  {{ $money(item.amount, item.currency) }}
                </td>
                <td class="text-right" v-if="reservations.length > 1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon @click="remove(item.id)" small class="mr-2" v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>{{ $lang("main.crud.remove") }}</span>
                  </v-tooltip>
                </td>
              </tr>
              <tr v-if="!reservations.length && !!errors.length">
                <td colspan="5" class="text-center">
                  <div v-for="(error, i) in errors" :key="i">
                    <span class="red--text">{{ error }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-pagination
          v-if="pagination.total > 5"
          v-model="page"
          :length="pagination.totalPages"
          :total-visible="7"
          circle
        />

      </v-container>
    </v-card-text>

    <v-layout row justify-center>
      <v-dialog v-model="isOpenImport" transition="dialog-bottom-transition" width="80%">
        <import-form
          v-if="isOpenImport"
          :company-id="companyId"
          :search-filter="client"
          @cancel="closeImport"
          @success="successImport"
        />
      </v-dialog>
    </v-layout>
  </v-card>
</template>

<script>
  import ImportForm from "@/pages/bills/partials/reservations/ImportForm";

  export default {
    name: "Reservations",
    components: {
      ImportForm
    },
    props: {
      companyId: {
        type: Number,
        required: false
      },
      items: {
        type: Array,
        required: false,
        default() {
          return [];
        }
      },
      errors: {
        type: Array,
        required: false,
        default() {
          return [];
        }
      },
      options: {
        type: Object,
        required: false,
        default: () => {
          return {};
        }
      },
      client: {
        type: String,
        required: false,
        default: null
      }
    },
    data() {
      return {
        page: 1,
        limit: 5,
        reservations: [],
        isOpenImport: false
      };
    },
    methods: {
      openImport() {
        this.isOpenImport = true;
      },
      closeImport() {
        this.isOpenImport = false;
      },
      successImport(reservations) {
        reservations.map((reservation) => {
          let isExisting = false;

          this.reservations.map((res) => {
            if (reservation.id === res.id) {
              isExisting = true;
            }
          });

          if (!isExisting) {
            this.reservations.push(reservation);
          }
        });

        this.$emit('changed', this.reservations);
        this.closeImport();
      },
      remove(id) {
        let index = null;

        this.reservations.map((reservation, i) => {
          if (reservation.id === id) {
            index = i;
          }
        });

        this.reservations.splice(index, 1);

        if (this.page > this.pagination.totalPages) {
          this.page = this.pagination.totalPages;
        }

        this.$emit('changed', this.reservations);
      }
    },
    computed: {
      pagination() {
        let items = this.reservations;

        const totalPages = Math.ceil(items.length / this.limit);
        const startIndex = this.limit * (this.page - 1);
        items = items.slice(startIndex, startIndex + this.limit);

        return {
          items: items,
          total: this.reservations.length,
          totalPages: totalPages
        };
      },
    },
    watch: {
      'companyId'() {
        this.reservations = [];
        this.$emit('changed', this.reservations);
      },
      items: {
        handler() {
          this.reservations = [ ...this.items ];
        },
        deep: true
      },
    }
  }
</script>

<style scoped>

</style>
